import React, { useState } from 'react';
import { useAuth } from '../authentication/AuthContext';
import '../styles/HomePage.css';
import '../styles/ExpandedPersonas.css'
import '../index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import '../i18n';
// import { useTranslation } from 'react-i18next';
import 'swiper/css/autoplay';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { useFormSubmit } from '../services/useFormSubmit';
import { Link } from 'react-router-dom';


function DigitalCustomerTwinPanel() {
  // const { t, i18n } = useTranslation();

  // useEffect(() => {
  //   i18n.changeLanguage(navigator.language);
  // }, []);

  const { user } = useAuth();
  const [expandedFAQ, setExpandedFAQ] = useState([false, false, false, false, false]);
  const { submitStatus, handleSubmit } = useFormSubmit();
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedFAQ(prev => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

 
  
  return (
    <div className="home-page">
      <div className="top-hero hero hero-1">
        <div className="hero-grid-item">
          <h1>Digital Customer Twin Panel</h1>
          <h3>Fast, reusable, and privacy-compliant digital customer twins</h3>
          <h3>built from real customer interviews.</h3>
          <h3>Ready in weeks, not months.</h3>
          
          <div className="button-container">
            <Link to="/use-cases" className="button secondary-button">Request Demo</Link>
          </div>
        </div>
       
      </div>

      <div className='hero hero-1'>
        <div className="problem-solution-grid">
        <div className="problem-solution-card problem-card">
          <h2>The Problem</h2>
          <h3>Traditional research can't keep up</h3>
          <p>Traditional research is slow, expensive, and hard to reuse. Every new question means starting from scratch.</p>
          <ul className="highlight-list">
            <li>Research takes <strong>2-3 months</strong> to complete, delaying critical decisions</li>
            <li>Insights quickly go stale or can't be repeated across markets</li>
            <li>Teams rely on assumptions and guesswork between studies</li>
          </ul>
        </div>
          
          <div className="problem-solution-card solution-card">
            <h2>The Solution</h2>
            <h3>Meet the Digital Customer Twin Panel</h3>
            <p>Digital twins of your real customers, ready to use and update whenever needed.</p>
            <ul className="highlight-list">
              <li>We conduct <strong>1–2-hour</strong> AI-assisted interviews with your customers and turn transcripts into intelligent digital twins.</li>
              <li>Once built, you can ask <span className="highlight">unlimited questions</span> instantly, securely, inside your private InstantFlows workspace.</li>
            </ul>
          </div>
        </div>
      </div>

      <div className='hero hero-1'>
        <div className="textbox">
          <h2>Results and ROI</h2>
          <p>Faster, cheaper, and continuously reusable.</p>
          <ul className="highlight-list">
            <li><strong>Live panel</strong> in <span className="highlight">2–4 weeks</span></li>
            <li><strong>Cheaper</strong> than traditional interviews</li>
            <li><strong>Continuous insights</strong> → faster decisions</li>
          </ul>
        </div>
      </div>

      <div className='hero hero-4'>
        <div className="textbox">
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Traditional Research</th>
                  <th>Digital Customer Twin Panel</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="label">Setup time</td>
                  <td>2–3 months</td>
                  <td className="emph">2–4 weeks</td>
                </tr>
                <tr>
                  <td className="label">Reusability</td>
                  <td>One-off</td>
                  <td className="emph">Unlimited Q&A</td>
                </tr>
                <tr>
                  <td className="label">Data depth</td>
                  <td>1× interview</td>
                  <td className="emph">Persistent, growing</td>
                </tr>
                <tr>
                  <td className="label">Privacy</td>
                  <td>Manual consent</td>
                  <td className="emph">GDPR, EU hosting option</td>
                </tr>
                <tr>
                  <td className="label">Quality</td>
                  <td>Not measurable</td>
                  <td className="emph">Calibrated (0.85 target)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className='hero hero-1' >
        <h2>How does it work?</h2>
        <Link to="/exampleresearches" className="how-to-image-link">
          <img 
            src="/how-to-picture.jpg" 
            alt="How to" 
            className="how-to-image desktop-image" 
          />
          <img 
            src="/how-to-picture-mobile.jpg" 
            alt="How to (mobile)" 
            className="how-to-image mobile-image" 
          />
        </Link>
      </div>

      <div className="hero hero-4" style={{ backgroundColor: 'var(--secondary-color)' }}>
        <div className="faq-grid">
          <div className="faq-header">
            <h2>Some questions you may have:</h2>
            {/* <div className="button-container">
              <Link to="/researchrequest" className="standout-button button">Request research</Link>
            </div> */}
          </div>
          <div className="faq-questions">
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(0)}>How long does it take to set up a panel?</h3>
              <div className={`faq-answer ${expandedFAQ[0] ? 'expanded' : ''}`}>
                <p> From kickoff to a live Customer Twin Panel usually takes 2–4 weeks, depending on participant scheduling and feedback rounds.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(1)}>What can I use the Customer Twins for?</h3>
              <div className={`faq-answer ${expandedFAQ[1] ? 'expanded' : ''}`}>
                <p>Typical use cases include:</p>
                <ul style={{marginTop: '0.5rem', marginBottom: '1rem', paddingLeft: '1.5rem'}}>
                  <li>Concept and messaging validation</li>
                  <li>Customer journey mapping</li>
                  <li>Onboarding or churn analysis</li>
                  <li>Pricing and feature testing</li>
                  <li>Continuous "voice of customer" insight</li>
                </ul>
                <p>Essentially, anywhere you'd run a survey or focus group — but faster and reusable.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(2)}>
What's the digital twins differ between the Digital Customer Twin Panel and the AI Instant Marketing Insights product?
</h3>
              <div className={`faq-answer ${expandedFAQ[2] ? 'expanded' : ''}`}>
                <p>This customer twin panel is an in-depth process in which your selected customers are interviewed and customer twins are made, based on each individual. This customer twin is then available to answer any questions you may have, at any time, in your personal InstantFlows library. Meanwhile the instant twins used in the AI Instant Market Insights product are ready-to-use twins created on the grounds of statistical and demographic data.</p> 
            </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(3)}>Can I trust the answers?</h3>
              <div className={`faq-answer ${expandedFAQ[3] ? 'expanded' : ''}`}>
                <p>  Yes. Each project includes a calibration step that compares the customer twin responses with the real answers of your customer, to check how closely they align. This helps you understand how reliable the insights are for your type of project.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(4)}>What about privacy and data security?</h3>
              <div className={`faq-answer ${expandedFAQ[4] ? 'expanded' : ''}`}>
                <p> All data used to generate digital twins is processed securely, anonymized, and hosted on EU servers if full compliance with GDPR.</p>
              </div>
            </div>
            </div>

        </div>
      </div>

        <div className="hero hero-1">

          <h2>Interested in InstantFlows?</h2>
          <div className="textbox">
            <p>Sign up to stay updated on our progress!</p>
            <form 
              id="interest-form" 
              action="https://script.google.com/macros/s/AKfycbz3X8mRhapnoT9XdfOdhJjXJhO2Q5X0Sz-0FbLsjCK81WlB0rOHiTP1ib3I6acjfC5dmg/exec" 
              method="POST" 
              className="interest-form"
              onSubmit={(e) => handleSubmit(e, 'interest-form')}
            >
              <input type="text" name="Name" placeholder="Your Name" required />
              <input type="email" name="Email" placeholder="Your Email" required />
              
              <button type="submit" className="button">Keep Me Updated</button>
              {submitStatus.message && (
                <div className={submitStatus.isError ? 'error-message' : 'success-message'}>
                  {submitStatus.message}
                </div>
              )}
            </form>
          </div>
        </div>
    </div>
  );
}

export default DigitalCustomerTwinPanel;